/**
 * Wireframe Example:
 * https://wireframe.check24.de/2022-1-29/mobile?customerArea=7&wishlist=1&search=2&footer=default&sab=0&notifications=1&navigation=rsn&breadcrumb=0&hotline=1&loginLayer=1&cart=0&responsive=0&layout=default&minified=0&cssInline=1&jsInline=1&package=0&product=25
 *
 * Wireframe Release Calendar:
 * https://confluence.check24.de/pages/viewpage.action?spaceKey=HWF&title=Release+Calendar
 */
export const WIREFRAME_VERSION_NUMBER = '2025-1-9';

// get latest version https://anmelden.check24.de/laststable
export const UNIFIED_LOGIN_WEB_COMPONENT_SCRIPT_VERSION = '20250116-1';

/**
 * Chatty Release Calendar: https://confluence.check24.de/display/HOCH/Release+Calendar
 */
export const CHATTY_VERSION = '2025-2-42';
